import React, { useRef, useState } from "react";
import { Helmet } from "react-helmet";
import { useReactToPrint } from "react-to-print";
import useSWR from "swr";
import { API } from "../../../StoreComponents/conflict";

const fetcher = (url) => API.get(url).then((res) => res.data.data);
const StockStatusAll = () => {
  const [printButton, setPrintButton] = useState(true);

  const {
    data: allEnties,
    error,
    mutate,
  } = useSWR(`store/reports/stockStatus?queryFor=all`, fetcher);
  console.log(allEnties);

  // print
  const componentRef = useRef();
  const handlePrint = useReactToPrint({
    content: () => componentRef.current,
  });

  return (
    <>
      <Helmet>
        <title>All Products - BBA STORE</title>
        <meta name="description" content="Product List - BBA STORE" />
      </Helmet>

      <div className="page-wrapper">
        <div className="content container-fluid main-container">
          <div className="d-flex align-items-center justify-content-between mb-4">
            <h1></h1>
            <button
              onClick={handlePrint}
              type="button"
              className={
                printButton
                  ? "btn btn-danger px-3 printBtn show"
                  : "printBtn btn btn-danger px-3"
              }
            >
              <i className="fa fa-print"></i>
              <span> Print</span>
            </button>
          </div>

          {/* Seach Element */}
          <div className="category show">
            <div className="mx-auto">
              {!allEnties ? (
                <div className="d-flex justify-content-center">
                  <div className="spinner-border" role="status">
                    <span className="visually-hidden">Loading...</span>
                  </div>
                </div>
              ) : (
                <div
                  ref={componentRef}
                  style={{ background: "white", borderRadius: "10px" }}
                >
                  <div className="text-center mt-4 mb-5">
                    <div>
                      <h4>
                        <b>INFOTECH IT SOLUTIONS</b>
                      </h4>

                      <h3>দ্রব্য লগ</h3>
                      <h3>Current Product Status</h3>
                    </div>
                  </div>
                  <div className="table-responsive-sm">
                    <table className="table table-bordered table-striped boder">
                      <thead>
                        <tr className="text-center">
                          <th className=" col-design1" colSpan="1">
                            S/N
                          </th>
                          <th className=" col-design1" colSpan="1">
                            Category
                          </th>
                          <th className=" col-design1" colSpan="1">
                            Product
                          </th>
                          <th className=" col-design1" colSpan="1">
                            Unit
                          </th>
                          <th className=" col-design1" colSpan="1">
                            Total IN
                          </th>
                          <th className=" col-design1" colSpan="1">
                            Total OUT
                          </th>
                          <th className=" col-design1" colSpan="1">
                            Current Stock
                          </th>
                        </tr>
                      </thead>
                      {allEnties ? (
                        <tbody>
                          {allEnties.map((product, index) => (
                            <tr key={index}>
                              <th className="text-center col-design1">
                                {index + 1}
                              </th>
                              <td className="text-start col-design1">
                                {product.CATEGORYEN}
                              </td>
                              <td className="text-start col-design1">
                                {product.PRONAME} <br />
                                {product.PRONAMETWO}
                              </td>
                              <td className="text-start col-design1">
                                {product.UNIT}
                              </td>
                              <td className="text-center col-design1">
                                {product.TOTAL + product.PROQTY}
                              </td>
                              <td className="text-center col-design1">
                                {product.TOTAL}
                              </td>
                              <td className="text-center col-design1">
                                {product.PROQTY}
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      ) : (
                        ""
                      )}
                    </table>
                  </div>
                </div>
              )}

              {/* Search Result */}
            </div>
          </div>
          {/* Seach Element */}
        </div>
      </div>
    </>
  );
};

export default StockStatusAll;
